import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/web.dom-collections.iterator.js";
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
/* Styles */
import "../style/pages/work-with-us.css";
import "@utils/LazyLoadingBg";
import { useVuelidate } from "@vuelidate/core";
import { required, helpers } from "@vuelidate/validators";
//@ts-ignore
import { BREAKPOINT } from "@customTypes/BreakpointEnum";
//@ts-ignore
import PublicUserMenu from "@vueEntry/PublicUserMenu.vue";
//@ts-ignore
import { useAppBanner } from "@wkComposables/useAppBanner";
//@ts-ignore
import CommonModals from "@vueEntry/CommonComponents/CommonModals";
//@ts-ignore
import { useFirebaseMessaging } from "@wkComposables/useFirebaseMessaging";
//@ts-ignore
import BaseInput from "@vueEntry/UIKitComponents/BaseInput.vue";
//@ts-ignore
import AccessibleSelect from "@vueEntry/UIKitComponents/AccessibleSelect.vue";
//@ts-ignore
import BaseCard from "@vueEntry/UIKitComponents/BaseCard.vue";
//@ts-ignore
import BaseUploadFile from "@vueEntry/UIKitComponents/BaseUploadFile.vue";
//@ts-ignore
import BaseButton from "@vueEntry/UIKitComponents/BaseButton.vue";
//@ts-ignore
import BaseBadge from "@vueEntry/UIKitComponents/BaseBadge.vue";
//@ts-ignore
import { sendJobApplicationForm } from "@services/mailAPI";
//@ts-ignore
import { useBaseSnackbar } from "@wkComposables/useBaseSnackbar";
import { createApp, defineAsyncComponent } from "vue";
//@ts-ignore
import { useValidator } from "@wkComposables/useValidator";
//@ts-ignore
import IntersectionObserverVue from "@vueEntry/IntersectionObserver/IntersectionObserverVue.vue";
//@ts-ignore
import IntersectionObservableVue from "@vueEntry/IntersectionObserver/IntersectionObservableVue.vue";
//@ts-ignore
import { EMAIL_REGEX, PHONE_REGEX } from "@utils/RegexUtils";
import { createPinia, mapState, mapActions } from "pinia";
import { useBaseStore, useModalStore, usePublicUserMenuStore, useLoggedUserStore
//@ts-ignore
} from "@store/index";
//@ts-ignore
import LanguageIcons from "@vueEntry/CommonComponents/LanguageIcons";
//@ts-ignore
import { useBreakpoints } from "@wkComposables/useBreakpoints";
//@ts-ignore
import { useTrustpilotWidget } from "@wkComposables/useTrustpilotWidget";
var emailValidator = helpers.regex(EMAIL_REGEX);
var phoneValidator = helpers.regex(PHONE_REGEX);
var workWithUsApp = createApp({
  name: "WorkWithUs",
  components: Object.assign(Object.assign(Object.assign({
    PublicUserMenu,
    IntersectionObservableVue,
    IntersectionObserverVue,
    //@ts-ignore
    SwiperCarousel: defineAsyncComponent(() => import("@vueEntry/SwiperCarousel.vue")),
    BaseBadge,
    BaseUploadFile,
    BaseInput,
    AccessibleSelect,
    BaseCard,
    BaseButton,
    //@ts-ignore
    "base-bt-modal": defineAsyncComponent(() => import("@vueEntry/BaseBtModal.vue"))
  }, CommonModals), {
    //@ts-ignore
    "async-dropdown": defineAsyncComponent(() => import("@vueEntry/UIKitComponents/BaseDropDown.vue"))
  }), LanguageIcons),
  setup() {
    var {
      isAppBannerVisible
    } = useAppBanner();
    var {
      showBaseSnackbar,
      handleShowSnackbar,
      baseSnackbarProps
    } = useBaseSnackbar();
    var {
      isValid
    } = useValidator();
    var {
      showFirebaseSnackbar,
      snackbarTitle,
      snackbarBody,
      snackbarIcon,
      handleOnForegroundNotificationClick
    } = useFirebaseMessaging();
    var {
      isLarge
    } = useBreakpoints();
    useTrustpilotWidget();
    return {
      v$: useVuelidate(),
      isLarge,
      isAppBannerVisible,
      showBaseSnackbar,
      handleShowSnackbar,
      baseSnackbarProps,
      //useFirebaseMessaging
      showFirebaseSnackbar,
      snackbarTitle,
      snackbarBody,
      snackbarIcon,
      handleOnForegroundNotificationClick,
      isValid
    };
  },
  data() {
    return {
      candidateBtnClicked: false,
      openJobPositionModal: false,
      jobDescriptionModalProps: null,
      jobPositionModalSelected: null,
      loading: false,
      candidate_name: "",
      surname: "",
      email: "",
      phone: "",
      jobPosition: {
        id: "",
        label: ""
      },
      cv: null,
      coverLetter: null,
      privacy: true,
      // props for cselect
      hideBackdrop: false,
      positionDesktop: "",
      modalFromDesktop: false
    };
  },
  validations() {
    return {
      candidate_name: {
        required
      },
      surname: {
        required
      },
      email: {
        required,
        emailValidator
      },
      phone: {
        phoneValidator
      },
      jobPosition: {
        notEmpty: v => {
          if (!v) return false;
          return "".concat(v.id).length > 0;
        }
      }
    };
  },
  computed: Object.assign(Object.assign(Object.assign({
    _workWithUsLabels() {
      return window["_workWithUsLabels"];
    },
    jobModalProps() {
      return window["_jobModalProps"];
    },
    jobPositionOptions() {
      return window["_jobPositionOptions"];
    }
  }, mapState(useLoggedUserStore, ["isUserLogged"])), mapState(usePublicUserMenuStore, ["favoritesCounter", "requestsCounter", "savedSearchesCounter", "mailConfirmed", "name"])), mapState(useModalStore, ["showModal"])),
  created() {
    this.initPublicUserMenu();
  },
  mounted() {
    if (window.screen.width > BREAKPOINT.SMALL) {
      this.hideBackdrop = true;
      this.positionDesktop = "position-absolute";
      this.modalFromDesktop = true;
    }
  },
  methods: Object.assign(Object.assign({
    onJobPositionModalClosed() {
      var _a;
      this.jobDescriptionModalProps = null;
      if (this.candidateBtnClicked) {
        (_a = document.getElementById("candidate")) === null || _a === void 0 ? void 0 : _a.scrollIntoView();
        this.candidateBtnClicked = false;
        this.jobPosition = this.jobPositionOptions.find(jp => jp.id === this.jobPositionModalSelected);
      }
    },
    closeModalAndScrollTo(jobPosition) {
      this.openJobPositionModal = false;
      this.jobPositionModalSelected = jobPosition;
    },
    openJobDescriptionModal(props, jobPosition) {
      var intern = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var headerTitle = jobPosition + (intern ? " - Intern" : "");
      this.jobDescriptionModalProps = Object.assign({
        jobPosition,
        headerTitle
      }, props);
      this.openJobPositionModal = true;
    },
    resetInput() {
      this.candidate_name = null;
      this.surname = null;
      this.email = null;
      this.phone = null;
      this.jobPosition = {
        id: "",
        label: ""
      };
      this.cv = null;
      this.coverLetter = null;
      this.v$.$reset();
    },
    submitApplication() {
      var _a;
      return __awaiter(this, void 0, void 0, function* () {
        this.v$.$touch();
        if (this.v$.$invalid) return;
        try {
          this.loading = true;
          var formData = new FormData();
          formData.append("preSubject", "Lavora con noi");
          formData.append("name", this.candidate_name || "");
          formData.append("surname", this.surname || "");
          formData.append("email", this.email || "");
          formData.append("phone", this.phone || "");
          formData.append("jobPosition", ((_a = this.jobPosition) === null || _a === void 0 ? void 0 : _a.label) || "");
          formData.append("cv", this.cv);
          formData.append("coverLetter", this.coverLetter);
          yield sendJobApplicationForm(formData);
          this.resetInput();
          this.handleShowSnackbar({
            type: "success",
            body: this._workWithUsLabels["applicationSuccess"]
          });
        } catch (e) {
          this.handleShowSnackbar({
            type: "error",
            body: "Si è verificato un errore imprevisto. Riprovare tra qualche secondo."
          });
        } finally {
          this.loading = false;
        }
      });
    },
    scrollToYourNextJob() {
      var jobPositions = this.$refs.jobPositions;
      jobPositions.scrollIntoView({
        behavior: "smooth"
      });
    },
    scrollToCandidate(jobPositionString) {
      var jobForm = this.$refs.jobForm;
      jobForm.scrollIntoView({
        behavior: "smooth"
      });
      this.jobPosition = jobPositionString;
    }
  }, mapActions(useModalStore, ["setShowModal"])), mapActions(useBaseStore, ["logout", "initPublicUserMenu"]))
});
workWithUsApp.use(createPinia());
workWithUsApp.mount("#work-with-us-main");